<template>
    <form>
        <div class="flex -mx-1 mb-4">
            <div class="form-group w-1/3 pl-1 pr-16">
                <label for="username" class="form-label">Korisničko ime</label>
                <input type="text" v-model="form.username" placeholder="Korisničko ime" class="form-control" id="username" @keydown.enter="onSubmit">
            </div>

            <div class="form-group w-1/3 pl-1 pr-16">
                <label for="email" class="form-label">E-mail</label>
                <input type="text" v-model="form.email" placeholder="E-mail adresa" class="form-control" id="email" @keydown.enter="onSubmit">
            </div>
        </div>

        <div class="flex -mx-1 mb-4">
            <div class="form-group w-full pl-1 pr-16">
                <label for="name" class="form-label">Ime</label>
                <input type="text" v-model="form.name" placeholder="Ime" class="form-control" id="name"
                       @keydown.enter="onSubmit">
            </div>
            <div class="form-group w-full pl-1 pr-16">
                <label for="last_name" class="form-label">Prezime</label>
                <input type="text" v-model="form.last_name" placeholder="Prezime" class="form-control" id="last_name"
                       @keydown.enter="onSubmit">
            </div>
            <div class="form-group w-full pl-1 pr-16">
                <label for="phone" class="form-label">Telefon</label>
                <input type="text" v-model="form.phone" placeholder="Telefon" class="form-control" id="phone" @keydown.enter="onSubmit">
            </div>
        </div>

        <div class="flex -mx-1 mb-4">
            <div class="form-group w-full pl-1 pr-16">
                <label for="responsible_person" class="form-label">Odgovorna osoba</label>
                <input type="text" v-model="form.responsible_person" placeholder="Odgovorna osoba" class="form-control" id="responsible_person" @keydown.enter="onSubmit">
            </div>
            <div class="form-group w-full pl-1 pr-16">
                <label for="company_id" class="form-label">Tvrtka</label>
                <select v-model="form.company_id"  @change="companyChange($event)" id="company_id" class="form-control" >
                    <option value="null" selected disabled>Odaberite tvrtku</option>
                    <option v-for="(val, key) in companies" :value="key" :key="key" v-text="val"></option>
                </select>
                <span class="mt-2 text-sm">Moguće je odabrati tvrtke koje imaju barem jedno skladište</span>
            </div>
            <div class="form-group w-full pl-1 pr-16">
                <label for="location_id" class="form-label">Skladište</label>
                <select v-model="form.location_id" id="location_id" class="form-control" >
                    <option value="null" selected disabled>Odaberite lokaciju</option>
                    <option v-for="(location, key) in locations" :value="location.id" :key="key" v-text="location.title"></option>
                </select>
                <div class="form-group pl-1 pr-16">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" v-model="form.can_manage_warehouse" class="custom-control-input" id="can_manage_warehouse">
                        <label class="custom-control-label _wrap" for="can_manage_warehouse" v-html="'Ovaj korisnik može upravljati skladištem kojem pripada'"></label>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex -mx-1 mb-4" v-if="user === null">
            <div class="form-group w-full pl-1 pr-16">
                <label for="password" class="form-label">Lozinka</label>
                <input type="password" v-model="form.password" placeholder="Lozinka" class="form-control" id="password" @keydown.enter="onSubmit">
            </div>

            <div class="form-group w-full pl-1 pr-16">
                <label for="password-confirmation" class="form-label">Ponovi lozinku</label>
                <input type="password" v-model="form.password_confirmation" placeholder="Ponovi lozinku" class="form-control" id="password-confirmation" @keydown.enter="onSubmit">
            </div>
        </div>

        <div class="flex -mx-1">
            <div class="form-group w-full pl-1 pr-16">
                <label for="password" class="form-label">Napomena</label>
                <textarea v-model="form.remark" class="form-control" id="remark" @keydown.enter="onSubmit">
                </textarea>
            </div>
        </div>

        <hr>

        <div class="form-group flex-row flex-wrap mb-8">
            <div class="w-full text-gray font-bold text-xl uppercase mb-2">Uloge:</div>
            <div class="custom-control custom-radio" v-for="(val, key) in roles" :key="`role-${key}`">
                <input type="radio" v-model="form.role" :value="key" class="custom-control-input" :id="`role-${key}`">
                <label class="custom-control-label" :for="`role-${key}`" v-html="val"></label>
            </div>
        </div>

        <template v-if="form.role === null">
            <div>Odaberite ulogu za korisnika.</div>
        </template>
        <div class="form-group flex-row flex-wrap" v-if="form.role !== null">
            <div class="w-full text-gray font-bold text-xl uppercase mb-2 mt-4">Dozvole:</div>
            <div
                class="custom-control custom-checkbox"
                v-for="(groups, groupKey) in rolePermissions[form.role]"
                :key="`permissions-${groupKey}`"
            >
              {{ groups }}
            </div>
        </div>

        <hr>

        <!-- TODO: Partial component with onSubmit code and route as prop -->
        <div class="buttons d-flex justify-content-end">
            <transition name="fade">
                <div class="is-processing" v-show="isProcessing">
                    <loading class="mr-2"></loading>
                </div>
            </transition>
            <button type="button" class="btn btn-lg btn-success flex" @click="onSubmit" :disabled="isProcessing">
                <img src="/svg/confirm.svg" alt="confirm" class="mr-2">
                <span v-html="_btnValue"></span>
            </button>
        </div>
    </form>
</template>

<script>
import Loading from '../Loading'
import Form from '../../core/Form'
import Axios from 'axios'

export default {
    props: {
        user: {
            type: Object,
            default: null,
        },

        roles: {
            required: true,
            type: Object
        },

        permissions: {
            required: true,
            type: Object
        },

        companies: {
            required: true,
            type: Object
        },

        rolePermissions: {
            required: true,
            type: Object,
        },

        authUser: {
            required: false,
            type: Object,
        },

        editPage: {
            required: false,
            type: Boolean,
            default: false,
        }
    },

    components: {
        Loading,
    },

    data() {
        return {
            locations: [],
            isProcessing: false,
            resetData: false,
            groupedPermissions: {},
            form: new Form({
                name: '',
                last_name: '',
                email: '',
                username: '',
                phone: '',
                remark: '',
                responsible_person: '',
                password: '',
                password_confirmation: '',
                location_id: '',
                company_id: '',
                role: '',
                can_manage_warehouse: false,
                permissions: [],
            }),
        }
    },

    created() {
        if (this.user !== null) {
            this.form.name = this.user.name
            this.form.last_name = this.user.last_name
            this.form.email = this.user.email
            this.form.username = this.user.username
            if(typeof(this.user.phone) !== 'undefined' && this.user.phone !== null) {
                this.form.phone = this.user.phone
            } else {
                this.form.phone = ''
            }
            if(typeof(this.user.responsible_person) !== 'undefined' && this.user.responsible_person !== null) {
                this.form.responsible_person = this.user.responsible_person
            } else {
                this.form.responsible_person = ''
            }

            if(typeof(this.user.remark) !== 'undefined' && this.user.remark !== null) {
                this.form.remark = this.user.remark
            } else {
                this.form.remark = ''
            }

            this.form.location_id = this.user.location_id
            this.form.company_id = this.user.company_id

            if (this.form.company_id) {
                this.oldSelectedCompany(this.form.company_id, this.form.location_id)
            }

            this.form.role = this.user.role_key
            this.form.permissions = this.user.permission_keys

            this.form.can_manage_warehouse = this.user.can_manage_warehouse
        }
    },

    mounted() {
        if (!auth.is_super_admin && this.editPage) {
            document.getElementById("company_id").disabled = true;
        }
    },

    computed: {
        _route() {
            return this.user === null
                ? {
                    name: route('admin.users.store'),
                    request: 'post',
                }
                : {
                    name: route('admin.users.update', this.user.id),
                    request: 'patch',
                }
        },

        _btnValue() {
            return this.user === null
                ? 'Dodaj korisnika'
                : 'Uredi korisnika'
        },
    },

    methods: {
        oldSelectedCompany(company_id, location_id) {
            let companyId = {'company_id': company_id}
            Axios.get(route('admin.api.company.warehouses', companyId))
                .then((response) => {
                    console.log(response.data)
                    this.locations = response.data
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        companyChange(event) {
            let companyId = {'company_id': event.target.value}
            Axios.get(route('admin.api.company.warehouses', companyId))
                .then((response) => {
                    this.locations = response.data
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        onSubmit() {
            this.isProcessing = true;

            this.form.permissions = ''

            if (this.form.role) {
                this.form.permissions = Object.keys(this.rolePermissions[this.form.role])
            }

            this.form[this._route.request](this._route.name)
                .then(response => {
                    Bus.$emit('onSuccess', response)

                    this.isProcessing = false
                })
                .catch(error => {
                    Bus.$emit('onFailure', error)

                    this.isProcessing = false
                })
        },

        groupPermissions() {
            for (let key in this.permissions) {
                let returnKey = ''
                let newKey = key.split('-')
                newKey.shift()

                for (let i = 0; i < newKey.length; i++) {
                    if (i > 0) {
                        returnKey += '-'
                    }

                    returnKey += newKey[i]
                }

                if (!this.groupedPermissions[returnKey]) {
                    this.groupedPermissions[returnKey] = []
                }

                this.groupedPermissions[returnKey].push({
                    key: key,
                    value: this.permissions[key]
                })
            }
        }
    }
}
</script>
